var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiIcon = function SvgAiIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0905344 4.60769C2.25387 5.04084 3.95937 6.74619 4.3923 8.90946C4.41597 9.03018 4.58284 9.03018 4.60769 8.90946C5.04084 6.74613 6.74619 5.04063 8.90946 4.60769C9.03018 4.58403 9.03018 4.41716 8.90946 4.39231C6.74613 3.95916 5.04063 2.25381 4.60769 0.0905344C4.58402 -0.0301781 4.41716 -0.0301781 4.3923 0.0905344C3.95916 2.25387 2.25381 3.95937 0.0905344 4.39231C-0.0301781 4.41598 -0.0301781 4.58284 0.0905344 4.60769Z",
    fill: "#E6F3FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai-icon.7e1c999bdc608ad6a327b6a1b4b45ae5.svg";